import { TableData, SearchParamsType } from "./types";

export const initialTableDataState: TableData = {
  recordViewItem: null,
  totalHits: 0,
};

export const initialSearchParams: SearchParamsType = {
  search_query: "",
  search_offset: 0,
  search_limit: 200,
  search_sort: "",
  search_order: "",
  res_option: "data",
  field_offset: 0,
  field_limit: 99,
};

export const initialSearchBodyParams: SearchParamsType = {
  search_query: "",
  search_offset: 0,
  search_limit: 200,
  search_sort: "",
  search_order: "",
  res_option: "body",
  field_offset: 0,
  field_limit: 99,
};
